(() => {
 if (window.txDisplayV12) return;
 window.txDisplayV12=true;
 const excluded='script,style,textarea,input,select,option,[contenteditable="true"],svg';
 const translate = text => text.replace(/\bOne\s+Size\b/gi,'Jedna veľkosť').replace(/\bOS\b/g,'Jedna veľkosť');
 const format = text => translate(text).replace(/€[\s\u00a0]*([0-9]+(?:[ .,\u00a0][0-9]{3})*(?:[,.][0-9]{2})?)/g,'$1\u00a0€');
 const normalize = root => {
  if(root.nodeType===Node.ELEMENT_NODE && root.tagName==='OPTION'){const old=root.textContent,value=translate(old);if(old!==value){if(!root.hasAttribute('value'))root.value=old;root.textContent=value;}return;}
  if (root.nodeType===Node.TEXT_NODE) { if(!root.parentElement?.closest(excluded)){const value=format(root.data);if(value!==root.data)root.data=value;} return; }
  if(root.nodeType!==Node.ELEMENT_NODE || root.closest(excluded))return;
  const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
  while(node=walker.nextNode())if(!node.parentElement.closest(excluded)){const value=format(node.data);if(value!==node.data)node.data=value;}
  // Option captions may be translated; submitted values must stay unchanged.
  root.querySelectorAll('option').forEach(option=>{const old=option.textContent,value=translate(old);if(old!==value){if(!option.hasAttribute('value'))option.value=old;option.textContent=value;}});
 };
 const syncAvailability = () => {
  document.querySelectorAll('[data-tx-pdp-availability]').forEach(target=>{
   const source=target.nextElementSibling?.querySelector('[data-selected-delivery]');
   const chosen=target.nextElementSibling?.querySelector('.tuzex-size-picker input:checked, input:checked');
   const text=!chosen ? 'Vyberte veľkosť — cena a termín doručenia sa zobrazia podľa nej.' : source && !source.hidden && source.textContent.trim() ? source.textContent.trim() : 'Dostupnosť sa zobrazí po overení skladových údajov.';
   if(target.textContent!==text)target.textContent=text;
   const state=source?.dataset.locationState || '';if(target.dataset.state!==state)target.dataset.state=state;
  });
 };
 normalize(document.body);syncAvailability();
 new MutationObserver(records=>{
  const nodes=new Set();for(const record of records){if(record.type==='characterData')nodes.add(record.target);else record.addedNodes.forEach(node=>nodes.add(node));}
  nodes.forEach(normalize);syncAvailability();
 }).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden','data-location-state']});
})();
